export default [  
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/modules/users/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Users List',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Users' }
      ]
    },
    children:[
      
      {
        path: 'create',
        name: 'users-create',
        component: () => import('@/views/modules/users/create'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'User Create',
          breadcrumb: [
            { text: 'Home',to: { name: "home" }  },
            { text: 'Users', to: { name: "users" }  },
            { text: 'Create' }
          ]
        }
      },
      {
        path: ':id/edit',
        props: true,
        name: 'users-edit',
        component: () => import('@/views/modules/users/edit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'User Edit',
          breadcrumb: [
            { text: 'Home', to: { name: "home" }  },
            { text: 'User', to: { name: "users-show" } , param: 'id' },
            { text: 'Edit' }
          ]
        }
      },
      {
        path: ':id/show',
        props: true,
        name: 'users-show',
        component: () => import('@/views/modules/users/show'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'User Details',
          breadcrumb: [
            { text: 'Home',to: { name: "home" }  },
            { text: 'Users', to: { name: "users" }  },
            { text: 'Details' }
          ]
        }
      },
    ]
  },

]